<template>
  <div class="profile-header">
    <router-link
      v-if="model.username"
      :to="{ name: 'model.username', params: { username: '@'+ model.username } }"
      class="profile-pic-container"
    >
      <div
        class="pic"
        :style="{backgroundImage: `url('${model.public_profile_image_path}')`}"
      ></div>
    </router-link>
    <router-link
      v-if="model.username"
      :to="{name: 'model.username', params: {username: '@'+model.username}}"
      class="profile-link"
    >
      <div class="names">
        <div v-if="model.name" class="name">
          {{ model.name }}
        </div>
      </div>
      <div class="verified">
        <img
          v-if="model.verified"
          class="badge-verified"
          src="/img/verified.png"
          alt="verified"
          title="verified"
        >
      </div>
    </router-link>
    <div class="blank"></div>
    <div class="container">
      <ButtonChatAtPost
        class="btn-chat"
        :model="model"
        v-if="_showChat"
      />
      <PostOptionsDropDown :modelId="model.id" :postId="post.post_id" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Model } from "@/types/Model";
import { Post } from "@/types/Post";

interface _Props {
  model?: Model;
  post?: Post;
  showChat?: boolean;
}

const { model, showChat, post } = withDefaults(defineProps<_Props>(), {
  showChat: false,
});

const _showChat = ref(false);

onMounted(() => {
  if ((!model || !model.chat) && post && post.chat && post.chat.data) {
    model.chat = post.chat.data;
  }

  if (
    (!model || !model.subscription_plans) &&
    post &&
    post.subscription_plans
  ) {
    model.subscription_plans = post.subscription_plans;
  }

  _showChat.value = showChat;
});

watch(
  () => post,
  () => {
    const isEnable = process.env.VUE_APP_CHAT_ENABLED === 'true';
    _showChat.value = isEnable && showChat && model.chat && model.chat.case != "hide_chat";
  }
);
</script>

<style scoped lang="scss">
.container {
  display: flex;
  position: relative;
  margin-inline: 0;

  .btn-chat {
    margin-right: 23px;
  }
}

.profile-pic-container {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-right: 5px;

  .pic {
    $SIZE: 43px;
    width: $SIZE;
    height: $SIZE;
    // margin: 5px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #ffffff;
    border-radius: 50%;
    border: 3px solid #ffffff;
  }
}

.blank {
  flex-grow: 1;
}

.profile-header {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 18px;

  .profile-link {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    overflow: hidden;

    .pic {
      width: 50px;
      height: 50px;
      margin: 5px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      background-color: #ffffff;
      border-radius: 50%;
      border: 3px solid #ffffff;
    }

    .names {
      display: flex;
      overflow: hidden;

      .name {
        // display: flex;
        display: block;
        align-items: center;

        font-size: 1em;
        font-weight: 600;
        text-wrap: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        img {
          &.badge-verified {
            width: 15px;
            margin: 3px 0 1px 2px;
            vertical-align: middle;
          }
        }
      }

      .username {
        color: #444;
        font-size: 0.8em;
      }

      &:hover {
        color: #666666;
      }
    }
  }

  .verified {
    display: block;
    align-items: center;

    img.badge-verified {
      width: 15px;
      margin: 0 5px 0 3px;
      vertical-align: middle;
    }
  }

  .post-options {
    align-self: center;
    .icon {
      width: 20px;
      height: 20px;
      padding-bottom: 0.75em;
      // padding-inline: 0.5em;
      background-image: url("/img/btn/three-dots.png");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }
}

.dropdown-container {
  position: absolute;
  margin-inline: 0px;
  right: 0%;

  .item,
  .dropdown-fake-container.active {
    min-width: 150px;
    text-align: center;
    color: inherit;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    padding-block: 0.75em;
    flex-grow: 1;
    transition: background-color 0.2s ease-in-out;

    &.router-link-active {
      background-color: lighten(#000000, 60);
    }

    &:hover {
      background-color: lighten(#000000, 75);
    }
  }

  .item {
    display: block;
  }

  .dropdown-fake-container {
    display: flex;
    justify-content: flex-end;

    &.active {
      padding-block: 0em;
      background-color: unset !important;
    }
  }

  .dropdown-btn {
    cursor: pointer;

    &.active {
      cursor: default;
    }
  }

  .dropdown-items {
    position: absolute;
    top: 100%;
    right: 0%;
    z-index: 9;
    background: lighten(#000000, 90);
  }
}
</style>
